export class ProtocolActivityDetailsBySerialCodeDataWrapper {
    position: number;
    protocolCode: string;
    activityCode: string;
    accountCode: string;
    email: string;
    startTime: number;
    title: string;
    exerciseType: string;
    duration: number;
    repetition: number;
    sensors: string;
    appVersion: string;

    constructor(position: number,
                protocolCode: string,
                activityCode: string,
                accountCode: string,
                email: string,
                startTime: number,
                title: string,
                exerciseType: string,
                duration: number,
                repetition: number,
                sensors: string,
                appVersion: string ) {
        this.position = position;
        this.protocolCode = protocolCode;
        this.activityCode = activityCode;
        this.accountCode = accountCode;
        this.email = email;
        this.startTime = startTime;
        this.title = title;
        this.exerciseType = exerciseType;
        this.duration = duration;
        this.repetition = repetition;
        this.sensors = sensors;
        this.appVersion = appVersion;
    }
}
